module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/busy_animation.9144092a45d75958fd2ced27fd5a1177.svg";